import type { AppEnvironment } from './types';
import { ESTATE_PAGE_COPY } from './page-copy-estate';

/**
 * Local development — Core SSO (hub + child communities) on localhost.
 * Login via Core `/portal-auth/login`; community switcher uses `sso.tenants`.
 * Hub tenant: `67ea2af1-bdf6-4d67-a556-5529ea855ddf` (test-1234).
 *
 * Optional: `public/runtime-env.js` can override domain for localhost.
 * For single-tenant direct login (SBM scratch), set authMode to `tenant` and
 * localDevDirectTenant + localDevTenantId in runtime-env.js instead.
 */
export const env: AppEnvironment = {
  production: false,
  buildMode: 'dev',
  apiBaseUrl: 'http://localhost:3002/v1',
  coreApiUrl: 'http://localhost:3000/v1',
  appTemplateId: 'a30964ed-6b73-4d5e-85c0-57507b5e37fc',
  authMode: 'core',
  localDevDirectTenant: false,
  localDevTenantId: '67ea2af1-bdf6-4d67-a556-5529ea855ddf',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: 'member-sudosky.com',
  rootTenantId: '67ea2af1-bdf6-4d67-a556-5529ea855ddf',
  portalBaseUrl: 'http://localhost:4303',
  appName: 'Community',
  version: '1.0.0',
  appShell: 'classic',
  appRatingEnabled: false,
  welcomeContent: {
    eyebrow: 'Community companion',
    title: 'The estate,\nin your pocket.',
    subtitle: 'Access and estate services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your estate or complex to continue.',
  },
  signupTermsUrl: 'https://www.ip4estates.com/terms',
  pageCopy: ESTATE_PAGE_COPY,
  home: {
    widgetMode: true,
    widgets: [
      { id: 'support', type: 'support', title: 'Helpdesk', order: 1, enabled: true, requiresModule: 'support' },
      { id: 'events', type: 'events', title: 'Upcoming events', order: 2, enabled: true, requiresModule: 'events' },
      { id: 'panic', type: 'panic', title: 'Emergency', order: 3, enabled: true, requiresModule: 'panic' },
      { id: 'utilities', type: 'utilities', title: 'Utilities', order: 4, enabled: true, requiresModule: 'utilities' },
    ],
  },
};
